angular.module('leanlaw').directive('llInvoiceInclude', ['$timeout', function ($timeout) {
  return {
    restrict: 'EA',
    template: require('./views/include.html'),
    scope: {
      format: '=',
      open: '=',
      fixed: '=',
      expenses: '='
    },
    link(scope, element, attrs) {
      scope.$watch('open', (open, prevOpen) => {
        if (open === prevOpen) return;
        $timeout(() => {
          element.find('button').click();
        }, 0, false);
      });
    }
  };
}]);